export const FileUploadConst = 
{
	key: "documents",
	label: "Dokümanlar",
	maxFileSize: "20971520",
	extensions: ["pdf", "pptx", "ppt", "doc", "docx"]
};